module.exports = __webpack_public_path__ + "static/media/AV.052bfe72.png";